import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import TitledLabel from '../../../controls/TitledLabel'
import Columns from '../../../styles/columns'
import CardStyles from '../../../styles/cards'
import NgrxDate from '../../../util/NgrxDateHelper'
import { localize } from '../../../util/Localizer'
import CollapsibleSection from '../../../controls/CollapsibleSection'

const AllocationHistory = (props) => {
  const allocationHistory = props.allocationHistory
  return (
    <CollapsibleSection
      id='allocationHistory'
      showMuiBorder={false}
      heading={localize('pages.hcsa.allocationHistory')}
      expanded={false}>

      {allocationHistory.map((allo, index) => {
        return (
          <Card key={index} className={props.classes.hcsaCard}>
            <Row>
              <Col {...Columns.max6}>
                <TitledLabel title={'pages.hcsa.allo.effectiveDate'} value={NgrxDate.SetDate(allo.effectiveDate)} />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title={'pages.hcsa.allo.allocationAmount'} value={allo.allocationAmount} format='currency' />
              </Col>
              <Col {...Columns.max6}>
                <TitledLabel title={'pages.hcsa.allo.creationDate'} value={NgrxDate.SetDate(allo.creationDate)} />
              </Col>
            </Row>
          </Card>
        )
      })}

    </CollapsibleSection>
  )
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(AllocationHistory)



// WEBPACK FOOTER //
// ./src/widgets/Member/Hsca/AllocationHistory.js